var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-description tw-text-gray-700 tw-text-base md:tw-text-lg tw-leading-relaxed"},[_vm._v(" "+_vm._s(_vm.lesson.description)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }